import b from 'b_';
import cx from 'classnames';
import React, { ReactNode } from 'react';

import './palette__default-item.scss';

interface Props {
    children: ReactNode;
    selected: boolean;
    mix?: string;
}

const PaletteDefaultItem = ({ children, selected, mix }: Props) => {
    return <div className={cx(b('palette', 'default-item', { selected }), mix)}>{children}</div>;
};

export default PaletteDefaultItem;
